import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const sizeClasses = {
    sm: "px-2.5 py-1.5 text-sm",
    md: "px-3 py-2 text-sm",
    lg: "px-4 py-3 text-base",
};
export function Input({ label, error, size = "md", className = "", id, ...rest }) {
    const inputId = id ?? label?.toLowerCase().replace(/\s+/g, "-");
    return (_jsxs("div", { className: className, children: [label ? (_jsx("label", { htmlFor: inputId, className: "mb-1 block text-sm font-medium text-[var(--color-foreground)]", children: label })) : null, _jsx("input", { id: inputId, "aria-invalid": !!error, className: [
                    "w-full rounded-[var(--radius-md)] border border-[var(--color-input)] bg-[var(--color-background)] text-[var(--color-foreground)] outline-none",
                    "focus:ring-2 focus:ring-[var(--color-ring)] focus:border-[var(--color-ring)]",
                    "disabled:opacity-50 disabled:cursor-not-allowed",
                    sizeClasses[size],
                ].join(" "), ...rest }), error ? (_jsx("p", { role: "alert", className: "mt-1 text-sm text-[var(--color-destructive)]", children: error })) : null] }));
}
